// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"SwipeList_actionBtn__BHVL0","list":"SwipeList_list__0Zyrv","page":"SwipeList_page__hmkDr"};